import React from 'react'
import { cn } from '../../utils/cn'

interface Props {
  className?: string
}

const IconManualBankTransfer = ({ className }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
    >
      <g clipPath='url(#clip0_329_2982)'>
        <path
          d='M1.5625 29.6875V48.4375M1.5625 45.3125H35.9375C35.9375 43.6549 35.279 42.0652 34.1069 40.8931C32.9348 39.721 31.3451 39.0625 29.6875 39.0625H21.875M21.875 39.0625C21.875 37.4049 21.2165 35.8152 20.0444 34.6431C18.8723 33.471 17.2826 32.8125 15.625 32.8125H1.5625M21.875 39.0625H14.0625M13.8125 1.5625H45.5625C46.3324 1.57348 47.0668 1.88847 47.6054 2.43877C48.1439 2.98907 48.4431 3.73002 48.4375 4.5V22.5833C48.4431 23.3533 48.1439 24.0943 47.6054 24.6446C47.0668 25.1949 46.3324 25.5099 45.5625 25.5208H13.8125C13.0426 25.5099 12.3082 25.1949 11.7696 24.6446C11.2311 24.0943 10.9319 23.3533 10.9375 22.5833V4.5C10.9319 3.73002 11.2311 2.98907 11.7696 2.43877C12.3082 1.88847 13.0426 1.57348 13.8125 1.5625Z'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={cn(
            'stroke-lightGray duration-300 transition-all',
            className,
          )}
        />
        <path
          d='M16.6666 8.33325H19.7916M39.5833 18.7499H42.7083M25 13.5416C25 14.7848 25.4938 15.9771 26.3729 16.8561C27.252 17.7352 28.4443 18.2291 29.6875 18.2291C30.9307 18.2291 32.1229 17.7352 33.002 16.8561C33.8811 15.9771 34.375 14.7848 34.375 13.5416C34.375 12.2984 33.8811 11.1061 33.002 10.227C32.1229 9.34795 30.9307 8.85409 29.6875 8.85409C28.4443 8.85409 27.252 9.34795 26.3729 10.227C25.4938 11.1061 25 12.2984 25 13.5416Z'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
          className={cn(
            'stroke-lightGray duration-300 transition-all',
            className,
          )}
        />
      </g>
      <defs>
        <clipPath id='clip0_329_2982'>
          <rect width='50' height='50' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconManualBankTransfer
